import React from 'react';
import { Box, Button, Icon, Popover, Typography } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../utils/localization';

import { invertedMessages } from './messages';

import './SaviPopover.css';

export function SaviPopover({
  title,
  description,
  isOpen,
  setIsOpen,
  children,
  value,
  onClick,
}) {
  const l = useInvertedLocalize(invertedMessages);

  const onPopoverClick = (flag) => {
    setIsOpen(flag);

    if (onClick) {
      onClick(flag);
    }
  };

  // TODO: Update these generic class names to suitcss utility conventions
  return (
    <Box className='Savi-Companion-Popover' value={value}>
      <Popover
        placement='bottom'
        trigger={children}
        popoverContent={
          <Box className='Savi-Companion-Popover-Wrapper'>
            <Box className='DisplayFlex'>
              <Icon kind='SaviCompanionGradient' size='medium' />
              <Typography kind='h3'>{title}</Typography>
            </Box>
            <Typography kind='body1' className='DescriptionText'>
              {description}
            </Typography>
            <Box className='flexWrapper'>
              <Button
                type='button'
                kind='filled'
                size='medium'
                onClick={() => onPopoverClick(false)}>
                {l('Got it')}
              </Button>
            </Box>
          </Box>
        }
        isOpen={isOpen}
        setIsOpen={onPopoverClick}
      />
    </Box>
  );
}
